<template>
    <svg :width="width" :height="height" :viewBox="`0 0 ${width} ${height}`" fill="none" xmlns="http://www.w3.org/2000/svg" :class="classes">
        <path d="M18.6667 2.66666H8.00004C6.53337 2.66666 5.33337 3.86666 5.33337 5.33332V26.6667C5.33337 28.1333 6.52004 29.3333 7.98671 29.3333H24C25.4667 29.3333 26.6667 28.1333 26.6667 26.6667V10.6667L18.6667 2.66666ZM24 26.6667H8.00004V5.33332H17.3334V12H24V26.6667Z" fill="#071689"/>
        <path d="M16 14V11.3333L12.6666 14.6667L16 18V15.3333C18.2066 15.3333 20 17.1267 20 19.3333C20 21.54 18.2066 23.3333 16 23.3333C13.7933 23.3333 12 21.54 12 19.3333H10.6666C10.6666 22.28 13.0533 24.6667 16 24.6667C18.9466 24.6667 21.3333 22.28 21.3333 19.3333C21.3333 16.3867 18.9466 14 16 14Z" fill="#32DAC3"/>
    </svg>
</template>

<script>
export default {
    name: "LastOrderIcon",

    props: {
        width: {
            type: Number,
            default: 32
        },

        height: {
            type: Number,
            default: 32
        },

        classes: {
            type: String
        }
    }
}
</script>